import { CreativesFilters } from 'components/common/types/Creative.types';
import { parseStatusFilter } from './parseStatusFilter';

export type ParsedCreativesStatusParams = {
  consumedParams: string[];
  filters: Partial<Pick<CreativesFilters, 'status' | 'automatic'>>;
};

export const parseCreativesStatusParams = (params: URLSearchParams): ParsedCreativesStatusParams => {
  const statusFilter = params.get('statusFilter');

  if (statusFilter !== null) {
    return {
      filters: parseStatusFilter(statusFilter),
      consumedParams: ['statusFilter'],
    };
  }

  const status = params.get('status');

  if (status !== null) {
    return {
      filters: { status: status.split(',').filter(Boolean) },
      consumedParams: ['status'],
    };
  }

  return {
    filters: {},
    consumedParams: [],
  };
};
